<template>
    <div>
        <v-dialog v-model="mostrar" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="$emit('cerrarDependencias')">
                        <v-icon>fa-times</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{calculo.nombre}}</v-toolbar-title>
                </v-toolbar>
                <v-card-text></v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="agregarDialog()" small>Agregar dependencias</v-btn>
                    <v-btn color="primary" @click="calcularDependencias()" small>Calcular todos</v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="calculo.dependencias"
                        :rows-per-page-items="[30,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    >

                     <template slot="items" slot-scope="props">
                         <td style="padding:2px;" class="text-xs-center">
                            <v-menu 
                                transition="scale-transition"
                                origin="left top"
                                bottom
                                right
                                slot="activator"
                            >
                                <v-btn class="ma-0" icon slot="activator">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                                <v-list class="app-card-action">
                                    <v-list-tile v-if="props.item.status != 'Calculado'"
                                        @click="calcularDependencia(props.item)"
                                        >
                                        <span>Calcular horario</span>
                                    </v-list-tile>
                                    <v-list-tile v-else @click="calcularDependencia(props.item)"><span>Recalcular horario</span></v-list-tile>
                                    <!-- <v-list-tile ><span>Quitar dependencia</span></v-list-tile> -->
                                </v-list>
                            </v-menu>

                        </td>
                         <td class="text-xs-left">{{ props.item.nombre }}</td>
                         <td>0</td>
                         <td>
                                <v-chip v-if="props.item.status == 'Sin calcular'"
                                    small dark color="orange">{{ props.item.status }}
                                </v-chip>
                                <v-chip v-else
                                    small dark color="green">{{ props.item.status }}
                                </v-chip>
                        </td>
                     </template>

                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- AGREGAR DEPENDENCIAS -->
        <v-dialog v-model="agregar.mostrar" scrollable width="400">
            <v-card>
                <v-card-title>Dependencias disponibles</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 400px;">
                    <div v-if="agregar.dependencias.length === 0"><i>No hay dependencias disponibles...</i></div>
                    <v-list dense>
                        <v-list-tile
                            v-for="(item, index) in agregar.dependencias"
                            :key="index"
                        >
                            <v-list-tile-action>
                                <v-checkbox
                                    v-model="item.check"
                                ></v-checkbox>
                            </v-list-tile-action>

                            <v-list-tile-content>
                            <v-list-tile-title v-text="item.nombre"></v-list-tile-title>
                            </v-list-tile-content>

                        </v-list-tile>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn small @click="seleccionarTodos()" :disabled="agregar.dependencias.length === 0">Todos</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat small @click="agregar.mostrar = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" 
                        dark small 
                        :disabled="agregar.dependencias.length === 0"
                        @click="agregarDependencias()">Agregar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="calculando.mostrar" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Calculando horarios</v-card-title>
                <v-card-text>
                    <v-progress-circular
                    indeterminate
                    color="primary"
                    ></v-progress-circular>
                   
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="calculando.mostrar = false">Disagree</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
     <v-dialog v-model="calculandoHorarios" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Calculando horarios</v-card-title>
                <v-card-text>
                    <v-progress-circular
                    indeterminate
                    color="primary"
                    ></v-progress-circular>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="calculandoHorarios = false">Disagree</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>
import { mapGetters } from "vuex";
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import axios from 'axios'
import _ from 'underscore'
import moment from 'moment-timezone'
moment.locale('es');

export default {
    name: 'CalculoDependencias',
    props:['mostrar','calculo'],
    mixins: [validationMixin],
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "tableProps",
            "role",
            "permisos"
        ]),
    },
    
        
    
    created(){
        // this.calculo = _.clone(this.calculoPadre);
        this.enviandoStart();
        axios.get(this.httpURL+'/calculo/listado/dependencias', {headers:{token: this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                this.enviandoStop();
                this.dependencias = res.data.dependencias;
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
    data() {
        return {
            // calculo: null,
            dependencias: [],
            headers:[
                {text:'', value:'props', sortable:false},
                {text:'Dependencia', value:'nombre', sortable:true},
                {text:'Registros', value:'registros', sortable:true},
                {text:'Status', value:'status', sortable:true}
            ],
            agregar:{
                mostrar: false,
                dependencias: [],
                todos: true,
            },
            calculando:{
                mostrar: false,
                dependencia: null
            },
            calculandoHorarios:false
        }
    },
    methods:{
        enviandoStart(){
            this.$emit('enviandoStart');
        },
        enviandoStop(){
            this.$emit('enviandoStop');
        },
        agregarDialog(){
            //Se obtienen las dependencias que no se han asignado
            this.agregar.dependencias = [];
            this.dependencias.forEach(element => {
                let index = this.calculo.dependencias.findIndex(x => x._id == element._id);
                if( index < 0){
                    this.agregar.dependencias.push({check:false, _id: element._id, nombre: element.nombre});
                }
            });
            this.agregar.mostrar = true;
        },
        seleccionarTodos(){
            this.agregar.dependencias.forEach(element => {
                element.check = this.agregar.todos;
            });
            this.agregar.todos = !this.agregar.todos;
        },
        agregarDependencias(){
            let dependencias = [];
            if( this.agregar.dependencias.length > 0 ){
                this.agregar.dependencias.forEach(element => {
                    if( element.check )
                        dependencias.push(element._id+'|'+element.nombre);
                });

                this.enviandoStart();
                axios.post(this.httpURL+'/calculo/agregar/dependencias/'+this.calculo._id, { dependencias: dependencias.toString()},
                    {headers:{token: this.sessionToken}})
                    .then(res => {
                        // console.log(res.data);
                        this.enviandoStop();
                        this.$emit('dependenciasAgregadas',this.calculo._id,res.data.dependencias)
                        this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                    })
                    .catch(error => {
                        // console.log(error);
                        this.enviandoStop();
                        this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                    });
            }
            // console.log(dependencias);
            this.agregar.mostrar = false;
        },
        calcularDependencias(){
            const idDependencias = this.calculo.dependencias.map(x=>{return x._id})
            this.calculandoHorarios = true;
         
            axios.post(this.httpURL+'/calculo/horario/dependencias/'+this.calculo._id,
                {dependencias: idDependencias},
                {headers:{token: this.sessionToken}})
                .then(res => {
                    this.calculandoHorarios=false;
                    if(res.data.ok){
                        this.$emit('dependenciasCalculada',this.calculo._id,);
                        this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                    }
                })
                .catch(error => {
                    // console.log(error);
                    this.calculandoHorarios=false;
                    // this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });   
        },
        calcularDependencia(dependencia){
            this.calculando.mostrar = true;
            this.calculando.dependencia = dependencia.nombre;

            // console.log(this.calculo._id, dependencia);
        
            // this.enviandoStart();
            axios.post(this.httpURL+'/calculo/horario/dependencia/'+this.calculo._id+'/'+dependencia._id,
                {},
                {headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res);
                    // this.enviandoStop();
                    this.$emit('dependenciaCalculada',this.calculo._id,dependencia._id);
                    this.calculando.mostrar = false;
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                    // this.$emit('depAgregadas');
                })
                .catch(error => {
                    // console.log(error);
                    this.calculando.mostrar = false;
                    // this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });       
        }

    }
}
</script>